import { createFileRoute, Navigate } from '@tanstack/react-router'

export const Route = createFileRoute('/_protected/runs/new/$agentId')({
  validateSearch: (search: Record<string, unknown>) => {
    const product_id = search.product_id
    const lot_start_date = search.lot_start_date
    const lot_end_date = search.lot_end_date

    return {
      product_id: typeof product_id === 'string' && product_id.trim() ? product_id.trim() : undefined,
      lot_start_date:
        typeof lot_start_date === 'string' && lot_start_date.trim() ? lot_start_date.trim() : undefined,
      lot_end_date:
        typeof lot_end_date === 'string' && lot_end_date.trim() ? lot_end_date.trim() : undefined,
    }
  },
  component: () => {
    const { agentId } = Route.useParams()
    const search = Route.useSearch()
    return (
      <Navigate
        to='/workflows/new/$agentId'
        params={{ agentId }}
        search={search}
        replace
      />
    )
  },
})
